"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.NetworkEnum = exports.RoleEnum = exports.FirmType = exports.StatusEnum = exports.ActionEnum = void 0;
var ActionEnum;
(function (ActionEnum) {
    ActionEnum["CREATE"] = "CREATE";
    ActionEnum["DELETE"] = "DELETE";
    ActionEnum["ACTIVATE"] = "ACTIVATE";
    ActionEnum["DEACTIVATE"] = "DEACTIVATE";
    ActionEnum["CHANGE"] = "CHANGE";
    ActionEnum["UPDATE_BRANCH_IDS"] = "UPDATE_BRANCH_IDS";
    ActionEnum["UPDATE_WEBSITE_URL"] = "UPDATE_WEBSITE_URL";
    ActionEnum["UPDATE_FIRM_TYPE"] = "UPDATE_FIRM_TYPE";
    ActionEnum["UPDATE_NAME"] = "UPDATE_NAME";
    ActionEnum["UPDATE_YEAR_FOUNDED"] = "UPDATE_YEAR_FOUNDED";
    ActionEnum["UPDATE_LEGAL_SHIELD_YEAR_JOINED"] = "UPDATE_LEGAL_SHIELD_YEAR_JOINED";
    ActionEnum["UPDATE_EXTERNAL_ID"] = "UPDATE_EXTERNAL_ID";
    ActionEnum["UPDATE_IDENTITY_PERMISSIONS"] = "UPDATE_IDENTITY_PERMISSIONS";
    ActionEnum["ADD_PERMISSIONS"] = "ADD_PERMISSIONS";
    ActionEnum["REMOVE_PERMISSIONS"] = "REMOVE_PERMISSIONS";
    ActionEnum["UPDATE_NETWORK"] = "UPDATE_NETWORK";
    ActionEnum["UPDATE_ABOUT_US_TEXT"] = "UPDATE_ABOUT_US_TEXT";
    ActionEnum["UPDATE_PROFILE_PICTURE_URL"] = "UPDATE_PROFILE_PICTURE_URL";
})(ActionEnum = exports.ActionEnum || (exports.ActionEnum = {}));
var StatusEnum;
(function (StatusEnum) {
    StatusEnum["CREATED"] = "CREATED";
    StatusEnum["ACTIVE"] = "ACTIVE";
    StatusEnum["DELETED"] = "DELETED";
    StatusEnum["DEACTIVATED"] = "DEACTIVATED";
})(StatusEnum = exports.StatusEnum || (exports.StatusEnum = {}));
var FirmType;
(function (FirmType) {
    FirmType["PARTNER"] = "PARTNER";
    FirmType["REFERRAL"] = "REFERRAL";
    FirmType["OTHER"] = "OTHER";
})(FirmType = exports.FirmType || (exports.FirmType = {}));
var RoleEnum;
(function (RoleEnum) {
    RoleEnum["ADMIN"] = "ADMIN";
    RoleEnum["CSR"] = "CSR";
    RoleEnum["LAWYER"] = "LAWYER";
    RoleEnum["RESOLUTION_LAWYER"] = "RESOLUTION_LAWYER";
    RoleEnum["RESOLUTION_CSR"] = "RESOLUTION_CSR";
    RoleEnum["REFERRAL_CLERK"] = "REFERRAL_CLERK";
    RoleEnum["PPLSI_MANAGEMENT"] = "PPLSI_MANAGEMENT";
    RoleEnum["INTAKES_VIEW"] = "INTAKES_VIEW";
    RoleEnum["DECOMMISSIONED_ADMIN"] = "DECOMMISSIONED_ADMIN";
})(RoleEnum = exports.RoleEnum || (exports.RoleEnum = {}));
var NetworkEnum;
(function (NetworkEnum) {
    NetworkEnum["LEGALSHIELD"] = "LEGALSHIELD";
    NetworkEnum["CLC"] = "CLC";
})(NetworkEnum = exports.NetworkEnum || (exports.NetworkEnum = {}));
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../utils");
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://firms.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Firms Service Api
 * @version v1
 * @baseUrl https://firms.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsGetFirms
             * @request GET:/v1/firms
             * @secure
             */
            firmsGetFirms: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsCreateFirm
             * @request POST:/v1/firms
             * @secure
             */
            firmsCreateFirm: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsGetSpecificFirm
             * @request GET:/v1/firms/{firmId}
             * @secure
             */
            firmsGetSpecificFirm: (firmId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsReplaceFirm
             * @request PUT:/v1/firms/{firmId}
             * @secure
             */
            firmsReplaceFirm: (firmId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsDeleteResource
             * @request DELETE:/v1/firms/{firmId}
             * @secure
             */
            firmsDeleteResource: (firmId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsUpdateBranchIds
             * @request POST:/v1/firms/{firmId}/updateBranchIds
             * @secure
             */
            firmsUpdateBranchIds: (firmId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/updateBranchIds`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsDeactivate
             * @request POST:/v1/firms/{firmId}/deactivate
             * @secure
             */
            firmsDeactivate: (firmId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/deactivate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsActivate
             * @request POST:/v1/firms/{firmId}/activate
             * @secure
             */
            firmsActivate: (firmId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/activate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsUpdateWebsiteUrl
             * @request POST:/v1/firms/{firmId}/updateWebsiteUrl
             * @secure
             */
            firmsUpdateWebsiteUrl: (firmId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/updateWebsiteUrl`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsUpdateFirmTypes
             * @request POST:/v1/firms/{firmId}/updateFirmTypes
             * @secure
             */
            firmsUpdateFirmTypes: (firmId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/updateFirmTypes`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsUpdateName
             * @request POST:/v1/firms/{firmId}/updateName
             * @secure
             */
            firmsUpdateName: (firmId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/updateName`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsUpdateYearFounded
             * @request POST:/v1/firms/{firmId}/updateYearFounded
             * @secure
             */
            firmsUpdateYearFounded: (firmId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/updateYearFounded`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsUpdateLegalShieldYearJoined
             * @request POST:/v1/firms/{firmId}/updateLegalShieldYearJoined
             * @secure
             */
            firmsUpdateLegalShieldYearJoined: (firmId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/updateLegalShieldYearJoined`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsUpdateExternalId
             * @request POST:/v1/firms/{firmId}/updateExternalId
             * @secure
             */
            firmsUpdateExternalId: (firmId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/updateExternalId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsUpdateIdentityPermisisons
             * @request POST:/v1/firms/{firmId}/updateIdentityPermissions
             * @secure
             */
            firmsUpdateIdentityPermisisons: (firmId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/updateIdentityPermissions`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsAddPermission
             * @request POST:/v1/firms/{firmId}/addPermission
             * @secure
             */
            firmsAddPermission: (firmId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/addPermission`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsRemovePermission
             * @request POST:/v1/firms/{firmId}/removePermission
             * @secure
             */
            firmsRemovePermission: (firmId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/removePermission`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsUpdateNetwork
             * @request POST:/v1/firms/{firmId}/updateNetwork
             * @secure
             */
            firmsUpdateNetwork: (firmId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/updateNetwork`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsUpdateAboutUsText
             * @request POST:/v1/firms/{firmId}/updateAboutUsText
             * @secure
             */
            firmsUpdateAboutUsText: (firmId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/updateAboutUsText`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsUpdateProfilePictureUrl
             * @request POST:/v1/firms/{firmId}/updateProfilePictureUrl
             * @secure
             */
            firmsUpdateProfilePictureUrl: (firmId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/updateProfilePictureUrl`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags FirmsJournal
             * @name FirmsJournalGetJournalChanges
             * @request GET:/v1/firms/journal
             * @secure
             */
            firmsJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags FirmsJournal
             * @name FirmsJournalGetMaxClock
             * @request GET:/v1/firms/journal/maxClock
             * @secure
             */
            firmsJournalGetMaxClock: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/journal/maxClock`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;
//# sourceMappingURL=firms.js.map